import { useState } from "react";
import { ActionButton, Dialog, DialogContent } from "@jhool-io/fe-components";
import { useParams } from "react-router-dom";
import { FORMS_AND_DOCUMENTATION_NOTE_LABELS } from "../../../../utils/constants";
import { IAddendumDetails } from "../../../../modules/notes/types/notes.types";
import NoteContentItem from "../NoteContentItem/NoteContentItem";
import { displayNameInRightFormat } from "../../../../utils/helpers";
import { useFetchSessionNote } from "../../../../hooks/queries/note";
import ViewFile from "../../../../shared-ui/ViewFile/ViewFile";
import { IViewFile } from "../../../../utils/types";

interface ViewFormsAndDocumentationNoteProps {
    noteContent: {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        [key: string]: any;
    };
    fieldAddendums: {
        [key: string]: IAddendumDetails[];
    } | null;
}

export default function ViewFormsAndDocumentationNote({
    noteContent,
    fieldAddendums,
}: ViewFormsAndDocumentationNoteProps) {
    const [docInView, setDocInView] = useState<IViewFile | null>(null);

    const params = useParams();
    const noteId = params.noteId as string;
    const clientId = params.clientId as string;

    const { data } = useFetchSessionNote(
        clientId,
        noteId,
        Boolean(clientId) && Boolean(noteId)
    );

    return (
        <>
            {docInView ? (
                <Dialog open={Boolean(docInView)}>
                    <DialogContent
                        title={
                            docInView?.document_name ??
                            "Note content attachment"
                        }
                        handleCloseDialog={() => {
                            setDocInView(null);
                        }}
                        showFooter={false}
                    >
                        <ViewFile
                            url={docInView.url}
                            contentType={
                                docInView?.metadata?.content_type ?? ""
                            }
                            title={
                                docInView?.document_name ??
                                "Note content attachment"
                            }
                        />
                    </DialogContent>
                </Dialog>
            ) : null}
            <NoteContentItem
                headerText={
                    FORMS_AND_DOCUMENTATION_NOTE_LABELS.forms_and_documentation_details
                }
                fieldId="forms_and_documentation_details"
                addendums={fieldAddendums?.forms_and_documentation_details}
                content={noteContent.forms_and_documentation_details ?? "--"}
            />
            <NoteContentItem
                headerText={FORMS_AND_DOCUMENTATION_NOTE_LABELS.files}
                fieldId="files"
                addendums={fieldAddendums?.files}
                content={
                    <div>
                        {data?.data?.note_content_documents &&
                        data?.data?.note_content_documents.length ? (
                            <div className="flex gap-[var(--spacing-items)] flex-wrap">
                                {data?.data?.note_content_documents.map(
                                    (doc) => (
                                        <ActionButton
                                            key={doc.note_content_document_id}
                                            variant="can-hover"
                                            size="auto"
                                            className="h-7 !text-text text-caption underline"
                                            actionTitle="View file"
                                            onClick={() => {
                                                setDocInView(doc);
                                            }}
                                        >
                                            <span>{`${displayNameInRightFormat(
                                                {
                                                    firstName:
                                                        doc.uploaded_by
                                                            .first_name,
                                                    lastName:
                                                        doc.uploaded_by
                                                            .last_name,
                                                },
                                                false
                                            )} -  ${doc.document_name}`}</span>
                                        </ActionButton>
                                    )
                                )}
                            </div>
                        ) : (
                            "--"
                        )}
                    </div>
                }
            />
        </>
    );
}
